import locale77427e78 from '../..\\..\\..\\lang\\en.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"locale":"en","fallbackLocale":"en","messages":{},"numberFormats":{"en-Us":{"currency":{"style":"currency","currency":"USD","currencyDisplay":"symbol","silentTranslationWarn":true}},"eu":{"currency":{"style":"currency","currency":"EUR","currencyDisplay":"symbol"}},"en-GB":{"currency":{"style":"currency","currency":"GBP","currencyDisplay":"symbol"}},"en-AU":{"currency":{"style":"currency","currency":"AUD","currencyDisplay":"symbol"}},"en-CA":{"currency":{"style":"currency","currency":"CAD","currencyDisplay":"symbol"}},"ja-JP":{"currency":{"style":"currency","currency":"JPY","currencyDisplay":"symbol"}},"zh-hk":{"currency":{"style":"currency","currency":"HKD","currencyDisplay":"symbol"}}}},
  vueI18nLoader: false,
  locales: [{"code":"fr","name":"Français","iso":"fr-FR","file":"fr.js"},{"code":"de","name":"Deutsch","iso":"de-de","file":"de.js"},{"code":"en","name":"English","iso":"en-US","file":"en.js"},{"code":"es","name":"Español","iso":"es","file":"es.js"},{"code":"it","name":"Italiano","iso":"it","file":"it.js"}],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "C:\\4Team_Git\\FT.Web.Products\\FT.Web.Templated\\lang",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","onlyOnNoPrefix":false,"onlyOnRoot":true,"useCookie":true},
  differentDomains: false,
  seo: true,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncLocale":false,"syncMessages":false,"syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  beforeLanguageSwitch: () => null,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"fr","name":"Français","iso":"fr-FR","file":"fr.js"},{"code":"de","name":"Deutsch","iso":"de-de","file":"de.js"},{"code":"en","name":"English","iso":"en-US","file":"en.js"},{"code":"es","name":"Español","iso":"es","file":"es.js"},{"code":"it","name":"Italiano","iso":"it","file":"it.js"}],
  localeCodes: ["fr","de","en","es","it"],
}

export const localeMessages = {
  'en.js': () => Promise.resolve(locale77427e78),
  'fr.js': () => import('../..\\..\\..\\lang\\fr.js' /* webpackChunkName: "lang-fr.js" */),
  'de.js': () => import('../..\\..\\..\\lang\\de.js' /* webpackChunkName: "lang-de.js" */),
  'es.js': () => import('../..\\..\\..\\lang\\es.js' /* webpackChunkName: "lang-es.js" */),
  'it.js': () => import('../..\\..\\..\\lang\\it.js' /* webpackChunkName: "lang-it.js" */),
}
